import { render } from "./DeleteDescription.vue?vue&type=template&id=5725d5f8"
import script from "./DeleteDescription.vue?vue&type=script&lang=js"
export * from "./DeleteDescription.vue?vue&type=script&lang=js"

import exportComponent from "/Users/klous/Documents/beye/src/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__